import { Component, Input, OnChanges } from '@angular/core';
import {
  getMprdProductType,
  NetflixBuyAndSellStatus,
  Option,
  TvProduct,
} from '@dch/products-business-logic';
import { savePii } from 'src/app/shared/pii/pii.utils';

@Component({
  selector: 'mprd-netflix-banner',
  templateUrl: './netflix-banner.component.html',
  styleUrls: ['./netflix-banner.component.css'],
})
export class NetflixBannerComponent implements OnChanges {
  @Input()
  product: TvProduct;

  @Input() isUnmigratedTvCustomer: boolean;

  shouldDisplayBanner: boolean;
  isBuyAndSellActive: boolean;
  netflixBuyAndSell: Option;
  packName: string;
  productType: string;

  savePii = savePii;

  constructor() {}

  ngOnChanges(): void {
    this.shouldDisplayBanner =
      this.product.netflixBuyAndSell === NetflixBuyAndSellStatus.ACTIVE ||
      this.product.netflixBuyAndSell === NetflixBuyAndSellStatus.AVAILABLE;

    this.isBuyAndSellActive =
      this.product.netflixBuyAndSell === NetflixBuyAndSellStatus.ACTIVE;
    this.netflixBuyAndSell =
      this.product &&
      this.product.options &&
      this.product.options.find(
        (option: Option) => option.optionCodeForDescription === 'MKIWR',
      );
    if (this.netflixBuyAndSell && this.netflixBuyAndSell.packDescription) {
      this.packName = this.netflixBuyAndSell.packDescription
        ?.replace(/Netflix/gi, '')
        .trim();
    }
    this.productType = this.product && getMprdProductType(this.product);
  }
}
